import React from 'react'; //eslint-disable-line no-unused-vars
import {Route, Redirect, Switch} from 'react-router';
import HomeView from '../views/home/HomeView';
import ServicesView from '../views/services/ServicesView';
import Error500 from '../views/error/Error500';
import Error404 from '../views/error/Error404';
import {getPath} from '@epic-core/common';
import SearchWrapper from '../views/search/SearchWrapper';
import BlankView from '../views/blank/BlankView';
import NewsView from '../views/news/NewsView';
import NewsDetailView from '../views/news/NewsDetailView';

const redirectLocale = (destination, route) => {
    const path = getPath();
    let destPath = null;
    if (typeof destination === 'function') {
        destPath = destination(route.match.params);
    } else {
        destPath = destination;
    }
    const redirectUrl = `${path}${route.match.params.locale}${destPath}${route.location.search || ''}`;
    return <Redirect to={redirectUrl} />;
};

const goHome = redirectLocale.bind(null, '/home');
const goServices = redirectLocale.bind(null, '/services');

const redirectUnreal = (destination, route) => <Redirect to="https://www.unrealengine.com/" />;
const redirectBranding = (destination, route) => <Redirect to="https://www.unrealengine.com/branding" />;
const redirectStore = (destination, route) => <Redirect to="https://www.epicgames.com/store/about" />;
const redirectEula = (destination, route) => <Redirect to="https://dev.epicgames.com/portal/eula" />;
const redirectAccount = (destination, route) => <Redirect to="https://www.epicgames.com/account" />;
const redirectSupport = (destination, route) => <Redirect to="https://eoshelp.epicgames.com" />;

const getRoutes = function getRoutes() {
    const path = getPath();
    const routes = (
        <Switch>
            <Route exact path={`${path}:locale/`} render={goHome} />
            <Route exact path={`${path}:locale/home`} component={HomeView} />
            <Route exact path={`${path}:locale/services`} component={ServicesView} />
            <Route exact path={`${path}:locale/bing-search`} component={SearchWrapper} />
            <Route exact path={`${path}:locale/search`} component={SearchWrapper} />
            <Route exact path={`${path}:locale/news`} component={NewsView} />
            <Route exact path={`${path}:locale/news/:title`} component={NewsDetailView} />

            <Route exact path={`${path}:locale/features`} render={goServices} />
            <Route exact path={`${path}:locale/engine`} render={redirectUnreal} />
            <Route exact path={`${path}:locale/store`} render={redirectStore} />
            <Route exact path={`${path}:locale/branding`} render={redirectBranding} />
            <Route exact path={`${path}:locale/eula`} render={redirectEula} />
            <Route exact path={`${path}:locale/account`} render={redirectAccount} />
            <Route exact path={`${path}:locale/services/terms`} render={redirectEula} />
            <Route exact path={`${path}:locale/support`} render={redirectSupport} />

            {/*Error pages*/}
            <Route path={`${path}:locale/page-not-found`} component={Error404} />
            <Route path={`${path}page-not-found`} component={Error404} />
            <Route path={`${path}:locale/error-404`} component={Error404} />
            <Route path={`${path}error-404`} component={Error404} />
            <Route path={`${path}:locale/unexpectedError`} component={Error500} />
            <Route path={`${path}unexpectedError`} component={Error500} />
            <Route path={`${path}:locale/error-500`} component={Error500} />
            <Route path={`${path}error-500`} component={Error500} />

            <Route path={`${path}*`} component={BlankView} />
        </Switch>
    );
    return routes;
};

export default getRoutes;
